<template>
    <b-navbar-toggle v-editable="blok" :target="target"></b-navbar-toggle>
</template>
<script>
export default {
    name: 'navigation-mobile-button-general',
    props: {
        target: {
            type: String,
            required: true
        },
        blok: {
            type: Object,
            required: true
        }
    }
}
</script>
